import { API_CONFIG } from '../config/api.config';

const ABSOLUTE_URL = /^[a-z][a-z0-9+.-]*:\/\//i;

export const toPublicAssetUrl = (input?: string | null): string => {
  const url = (input || '').trim();
  if (!url) return '';
  if (ABSOLUTE_URL.test(url) || url.startsWith('data:') || url.startsWith('blob:')) {
    return url;
  }
  if (url.startsWith('/')) {
    return `${API_CONFIG.getBaseUrl()}${url}`;
  }
  return url;
};

export const normalizeHtmlAssetUrls = (html?: string | null): string => {
  if (!html) return '';
  return html.replace(/(src|href|poster)=("|\')([^"']+)\2/g, (_match, attr, quote, url) => {
    const normalized = toPublicAssetUrl(url);
    if (!normalized || normalized === url) {
      return `${attr}=${quote}${url}${quote}`;
    }
    return `${attr}=${quote}${normalized}${quote}`;
  });
};
